var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-simplePage-list"},[_c('a-card',{attrs:{"bordered":false}},[_vm._v(" 这个页面将被缓存，跳转到详情，input内容会保存。需要重载得话，需要切换目录，或在跳转前手动调用this.$routex.refreshNext() "),_c('a-input',{attrs:{"placeholder":"输入的内容将被缓存"}}),_c('a-button',{on:{"click":_vm.toDetail}},[_vm._v("跳转详情")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }